import React, { useState } from 'react';
import { createRoot } from 'react-dom/client';
import cx from 'classnames';
import { pick } from 'lodash-es';

import AppSelection from './components/AppSelection';
import ProcessingSmartSearch from './components/ProcessingSmartSearch';
import ReportGeneration from './components/ReportGeneration';
import ReachedReportLimit from './components/ReachedReportLimit';
import SuccessStep from './components/SuccessStep';
import ErrorScreen from './components/ErrorScreen';

import { rootNode, initParams } from './configs';
import { InitialDataProvider } from './context';

const { preSelectedApp, customTitles, updatedReportStep, sharedByReportId } = initParams;

const providerData = {
  ...pick(initParams, ['popularApps', 'sitekey']),
  createReportParams: {
    shared_by_report_id: sharedByReportId,
    skip_user: false,
    bdr_generated: false,
  },
};

const initialStep = (() => {
  if (updatedReportStep) return 'updated-report-step';

  if (preSelectedApp.length > 1) return 'processing-smart-search';

  return 'app-selection';
})();

const SmartSearchReport = () => {
  const [step, setStep] = useState(initialStep);
  const [selectedApps, setSelectedApps] = useState(preSelectedApp);
  const [reportCharts, setReportCharts] = useState();

  return (
    <InitialDataProvider value={providerData}>
      <div className={cx('smart-search-report', `${step}-step`)}>
        {step === 'app-selection' && (
          <AppSelection
            selectedApps={selectedApps}
            customTexts={customTitles}
            onAppsChange={setSelectedApps}
            onStepChange={setStep}
          />
        )}
        {step === 'processing-smart-search' && (
          <ProcessingSmartSearch
            selectedApps={selectedApps}
            onAppsChange={setSelectedApps}
            onChartsChange={setReportCharts}
            onStepChange={setStep}
          />
        )}
        {step === 'report-generation' && (
          <ReportGeneration
            selectedApps={selectedApps}
            reportCharts={reportCharts}
            onAppsChange={setSelectedApps}
            onChartsChange={setReportCharts}
            onStepChange={setStep}
          />
        )}
        {step === 'reached-report-limit' && <ReachedReportLimit />}
        {step === 'updated-report-step' && (
          <SuccessStep action="update" onReset={() => setStep('app-selection')} />
        )}
        {step === 'error-step' && <ErrorScreen />}
      </div>
    </InitialDataProvider>
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<SmartSearchReport />);
});
